class AuthorStory extends HTMLElement {
  constructor() {
    super();

    this.media = null;
    this.video = null;
    this.playButton = null;

    this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
    this.handleVideoPlay = this.handleVideoPlay.bind(this);
    this.handleVideoPause = this.handleVideoPause.bind(this);
    this.handleVideoEnded = this.handleVideoEnded.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    if (this.dataset.initialized === 'true') {
      return;
    }

    this.media = this.querySelector('.author-story__media');
    this.video = this.querySelector('.author-story__video');
    this.playButton = this.querySelector('.author-story__play-button');

    if (!this.media || !this.video || !this.playButton) {
      return;
    }

    this.dataset.initialized = 'true';

    this.setupVideo();
    this.bindEvents();
  }

  setupVideo() {
    this.video.pause();

    /*
     * Do not mute the video.
     * The video should retain its original audio.
     * Since playback is triggered by the user's click,
     * browser autoplay restrictions do not prevent audio playback.
     */
    this.video.muted = false;

    this.media.classList.remove('is-playing');
    this.media.classList.remove('has-started');

    this.playButton.setAttribute('aria-label', 'Play video');
  }

  bindEvents() {
    this.playButton.addEventListener(
      'click',
      this.handlePlayButtonClick
    );

    this.video.addEventListener(
      'play',
      this.handleVideoPlay
    );

    this.video.addEventListener(
      'pause',
      this.handleVideoPause
    );

    this.video.addEventListener(
      'ended',
      this.handleVideoEnded
    );
  }

  handlePlayButtonClick() {
    if (this.video.paused) {
      /*
       * Make sure audio is enabled when the user explicitly
       * starts the video.
       */
      this.video.muted = false;

      const playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          this.media.classList.remove('is-playing');
          this.media.classList.remove('has-started');

          this.playButton.setAttribute(
            'aria-label',
            'Play video'
          );
        });
      }
    } else {
      this.video.pause();
    }
  }

  handleVideoPlay() {
    this.media.classList.add('is-playing');
    this.media.classList.add('has-started');

    this.playButton.setAttribute(
      'aria-label',
      'Pause video'
    );
  }

  handleVideoPause() {
    this.media.classList.remove('is-playing');

    this.playButton.setAttribute(
      'aria-label',
      'Play video'
    );
  }

  handleVideoEnded() {
    this.media.classList.remove('is-playing');

    this.playButton.setAttribute(
      'aria-label',
      'Play video'
    );
  }

  destroy() {
    if (!this.video || !this.playButton) {
      return;
    }

    this.playButton.removeEventListener(
      'click',
      this.handlePlayButtonClick
    );

    this.video.removeEventListener(
      'play',
      this.handleVideoPlay
    );

    this.video.removeEventListener(
      'pause',
      this.handleVideoPause
    );

    this.video.removeEventListener(
      'ended',
      this.handleVideoEnded
    );

    this.dataset.initialized = 'false';

    this.media = null;
    this.video = null;
    this.playButton = null;
  }
}

if (!customElements.get('author-story')) {
  customElements.define(
    'author-story',
    AuthorStory
  );
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    const section = event.target;

    if (
      section.matches &&
      section.matches('.section-author-story')
    ) {
      const component = section.querySelector('author-story');

      if (component) {
        component.init();
      }
    }
  }
);

document.addEventListener(
  'shopify:section:reorder',
  () => {
    document
      .querySelectorAll('author-story')
      .forEach((component) => {
        component.init();
      });
  }
);

document.addEventListener(
  'shopify:section:select',
  (event) => {
    const section = event.target;

    if (
      section.matches &&
      section.matches('.section-author-story')
    ) {
      const component = section.querySelector('author-story');

      if (component) {
        component.init();
      }
    }
  }
);

document.addEventListener(
  'shopify:section:deselect',
  (event) => {
    const section = event.target;

    if (
      section.matches &&
      section.matches('.section-author-story')
    ) {
      const component = section.querySelector('author-story');

      if (component) {
        component.init();
      }
    }
  }
);